export const EntityType = [
  { key: 'Service', label: 'Service' },
  { key: 'All', label: 'All' },
  { key: 'Endpoint', label: 'Service endpoint' },
  { key: 'ServiceInstance', label: 'Service instance' }
];
export const BrowserEntityType = [
  { key: 'Service', label: 'Service' },
  { key: 'All', label: 'All' },
  { key: 'Endpoint', label: 'Page path' },
  { key: 'ServiceInstance', label: 'Service version' }
];

export const IndependentType = [
  { key: 'true', label: 'Self selectors' },
  { key: 'false', label: 'Common selectors' }
];

export enum MetricsType {
  UNKNOWN = 'UNKNOWN',
  REGULAR_VALUE = 'REGULAR_VALUE',
  LABELED_VALUE = 'LABELED_VALUE',
  HEATMAP = 'HEATMAP',
  SAMPLED_RECORD = 'SAMPLED_RECORD'
}

export const QueryMetricTypes: {
  [key: string]: Array<{ label: string; value: string }>;
} = {
  REGULAR_VALUE: [
    {
      label: 'Read the single value in the duration',
      value: 'readMetricsValue'
    },
    { label: 'Read all values in the duration', value: 'readMetricsValues' },
    { label: 'Get sorted top N values', value: 'sortMetrics' }
  ],
  LABELED_VALUE: [
    {
      label: 'Read all values of labels in the duration',
      value: 'readLabeledMetricsValues'
    }
  ],
  HEATMAP: [
    { label: 'Read heatmap values in the duration', value: 'readHeatMap' }
  ],
  SAMPLED_RECORD: [
    { label: 'Get sorted topN values', value: 'readSampledRecords' }
  ]
};

export const MetricChartType: { [key: string]: string } = {
  readMetricsValue: 'ChartNum',
  readMetricsValues: 'ChartLine',
  sortMetrics: 'ChartSlow',
  readLabeledMetricsValues: 'ChartLine',
  readHeatMap: 'ChartHeatmap',
  readSampledRecords: 'ChartSlow'
};

export const CalculationType = [
  { label: 'Plus', value: '+' },
  { label: 'Minus', value: '-' },
  { label: 'Multiplication', value: '*' },
  { label: 'Division', value: '/' },
  {
    label: 'Convert unix timestamp(milliseconds)',
    value: 'milliseconds'
  },
  { label: 'Convert unix timestamp(seconds)', value: 'seconds' }
];

export const ChartTypeOptions = [
  { value: 'ChartLine', label: 'Line chart' },
  { value: 'ChartArea', label: 'Area chart' },
  { value: 'ChartBar', label: 'Bar chart' }
];

export const ALL_METRIC_OPTION = { value: 'All', label: 'All' };